// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../www/nav-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../www/nav-right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../www/patternnew.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-wrapper {
  position: relative;
  width: 100%;
  background-color: #fff;
  height: 84px !important;
}
.nav-wrapper:before, .nav-wrapper:after {
  content: "";
  position: absolute;
  width: 147px;
  height: 100%;
  background-repeat: no-repeat;
  top: 0px;
  opacity: 0;
}
.nav-wrapper:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  left: 0px;
}
.nav-wrapper:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  right: 0px;
}
.nav-wrapper .navigation-bg {
  position: absolute;
  z-index: 0;
  bottom: 0;
  width: 100%;
}
.nav-wrapper .nav-container {
  position: relative;
  box-shadow: 0 0 2px 2px #e1e1e1;
  border-radius: 6px 6px 0 0;
  height: 80px;
  margin-top: 4px;
}
.nav-wrapper .nav-container:before {
  content: "";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 85px;
  height: 88px;
  top: -4px;
  left: 0;
  right: 0;
  margin: auto;
  background-repeat: no-repeat;
}
.nav-wrapper .customNavItem {
  width: 80px;
}
.nav-wrapper .customNavItem .customNavBar {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 20px;
}
.nav-wrapper .customNavItem .customNavBar .customIconContainer {
  background-color: #4FADA6;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.2);
  width: 52px;
  height: 52px;
  border-radius: 50%;
  position: relative;
}
.nav-wrapper .customNavItem .customNavBar .customIconContainer.active {
  background-color: #071C3E;
}
.nav-wrapper .customNavItem .customNavBar .customIconContainer svg {
  position: absolute;
  top: 8px;
  left: 10px;
}
.nav-wrapper .customNavItem .customNavBar .customIconContainer .active-dot {
  position: relative;
}
.nav-wrapper .customNavItem .customNavText {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: -1px;
}`, "",{"version":3,"sources":["webpack://./BottomNavBar.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;AACJ;AAEI;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,QAAA;EACA,UAAA;AADR;AAII;EACI,yDAAA;EACA,SAAA;AAFR;AAII;EACI,yDAAA;EACA,UAAA;AAFR;AAII;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAFR;AAKI;EACI,kBAAA;EACA,+BAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AAHR;AAIQ;EACI,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,4BAAA;AAFZ;AAMI;EACI,WAAA;AAJR;AAMQ;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAJZ;AAMY;EACI,yBAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAJhB;AAMgB;EACI,yBAAA;AAJpB;AAOgB;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AALpB;AAQgB;EACI,kBAAA;AANpB;AAYQ;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAVZ","sourcesContent":[".nav-wrapper {\n  position: relative;\n  width: 100%;\n  background-color: #fff;\n  height: 84px !important;\n}\n.nav-wrapper:before, .nav-wrapper:after {\n  content: \"\";\n  position: absolute;\n  width: 147px;\n  height: 100%;\n  background-repeat: no-repeat;\n  top: 0px;\n  opacity: 0;\n}\n.nav-wrapper:before {\n  background-image: url(\"../../../../www/nav-left.png\");\n  left: 0px;\n}\n.nav-wrapper:after {\n  background-image: url(\"../../../../www/nav-right.png\");\n  right: 0px;\n}\n.nav-wrapper .navigation-bg {\n  position: absolute;\n  z-index: 0;\n  bottom: 0;\n  width: 100%;\n}\n.nav-wrapper .nav-container {\n  position: relative;\n  box-shadow: 0 0 2px 2px #e1e1e1;\n  border-radius: 6px 6px 0 0;\n  height: 80px;\n  margin-top: 4px;\n}\n.nav-wrapper .nav-container:before {\n  content: \"\";\n  position: absolute;\n  background-image: url(\"../../../../www/patternnew.png\");\n  width: 85px;\n  height: 88px;\n  top: -4px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  background-repeat: no-repeat;\n}\n.nav-wrapper .customNavItem {\n  width: 80px;\n}\n.nav-wrapper .customNavItem .customNavBar {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: 20px;\n}\n.nav-wrapper .customNavItem .customNavBar .customIconContainer {\n  background-color: #4FADA6;\n  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.2);\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  position: relative;\n}\n.nav-wrapper .customNavItem .customNavBar .customIconContainer.active {\n  background-color: #071C3E;\n}\n.nav-wrapper .customNavItem .customNavBar .customIconContainer svg {\n  position: absolute;\n  top: 8px;\n  left: 10px;\n}\n.nav-wrapper .customNavItem .customNavBar .customIconContainer .active-dot {\n  position: relative;\n}\n.nav-wrapper .customNavItem .customNavText {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: -1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
